module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2023_fr-4af03fd370cfa856a9ba69b78cf5c700.jpg";